// Exports
export default {
	"activeIcon": "activeIcon_nfWmQ",
	"Button": "Button_TUirY",
	"collapsible": "collapsible_BgQ+H",
	"small": "small_Y2aPw",
	"isSidebarVisible": "isSidebarVisible_GKscr",
	"default": "default_iZFpA",
	"huge": "huge_px68z"
};
